import Axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import Storage from "../storage";
import AuthService from "./auth-service";

export interface IePharmaServicesResponse
{
    data: any;
    error: {
        code: number;
        message: string;
    };
    messages:  {
        index: number;
        message: string;
    }[];
    pagination: {
        page: number;
        itemsPerPage: number;
        totalItems: number;
        totalPages: number;
    };
    success: boolean;
}

export default function ePharmaServices(baseUrl: string)
{
    const api = Axios.create({ baseURL: baseUrl });

    api.interceptors.request.use((config: AxiosRequestConfig) =>
    {
        const token = Storage.token.get();
        if (token && (token as any).accessToken)
        {
            if (!config.headers) config.headers = {} as any;
            (config.headers as any)["Authorization"] = `Bearer ${token.accessToken}`;
        }
        return config;
    });

    api.interceptors.response.use((response: AxiosResponse<any>) => response, async error =>
    {
        const { response, config } = error || {};
        if (response)
        {
            switch (response.status)
            {
                case 401:
                    if (config && !config.__retryAuth)
                    {
                        try
                        {
                            const access = await AuthService.setTokenAuthenticationService();
                            if (access)
                            {
                                Storage.token.set({ accessToken: access, expires: '' });
                                config.__retryAuth = true;
                                config.headers = config.headers || {} as any;
                                (config.headers as any)["Authorization"] = `Bearer ${access}`;
                                return api.request(config);
                            }
                        }
                        catch (e)
                        {
                            // fallthrough to error handling below
                        }
                    }
                    return Promise.reject(error);
                case 403:
                    return window.location.href = "/error"
                default:
                    return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    });
    
    return api;
} 
